import { ICustomField } from "store/entities/custom-fields/interfaces";

import { IKeyAny } from "../api-client";
import { BaseApi } from "../base";

type ICreateCustomFieldPayload = Pick<
  ICustomField,
  "displayName" | "type" | "apiKey" | "roleLevel" | "status" | "teamIDs"
>;

export interface IUpdateCustomFieldPayload extends ICreateCustomFieldPayload {
  id?: string;
}

function parsePayload(payload: ICreateCustomFieldPayload): IKeyAny {
  const { displayName, type, apiKey, roleLevel, status, teamIDs } = payload;
  return {
    displayName,
    teamIDs,
    type,
    apiKey,
    roleLevel,
    status,
  };
}

function parseUpdatePayload(payload: IUpdateCustomFieldPayload): IKeyAny {
  const { displayName, type, apiKey, roleLevel, status, teamIDs } = payload;
  return {
    displayName,
    type,
    apiKey,
    roleLevel,
    status,
    teamIDs,
  };
}

export default class CustomFieldApi extends BaseApi {
  protected readonly prefix = "customFields";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (payload: ICreateCustomFieldPayload) => this.post("", parsePayload(payload));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (payload: IUpdateCustomFieldPayload) => this.patch(payload.id, parseUpdatePayload(payload));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteTagCustomField = (id: string) => this.delete(id);
}
